import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flag-mx",
  "use": "icon-flag-mx-usage",
  "viewBox": "0 0 1568 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1568 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-flag-mx\"><defs><style type=\"text/css\"></style></defs><path d=\"M141.824 0h1268.64c80.704 0 144.288 63.392 144.288 138.976v746.016c0 78.016-63.584 138.976-141.824 138.976H141.824C63.584 1023.968 0 960.576 0 884.992V138.976C0 63.392 63.584 0 141.824 0z\" fill=\"#FFFFFF\" p-id=\"4604\" /><path d=\"M520.864 1023.936V0H0v1023.936z\" fill=\"#006847\" p-id=\"4605\" /><path d=\"M1556.48 1023.936H1044.128V0H1556.48z\" fill=\"#CE1126\" p-id=\"4606\" /><path d=\"M611.328 511.968c0 94.24 76.64 170.656 171.168 170.656s171.168-76.416 171.168-170.656c0-94.24-76.64-170.656-171.168-170.656s-171.168 76.416-171.168 170.656z\" fill=\"#EABC28\" p-id=\"4607\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag-mx.svg
// module id = OP7p
// module chunks = 24